import React, { useMemo } from 'react';
import _ from 'lodash';

const EnhancedSelect = ({ 
  name,
  value, 
  onChange, 
  className, 
  onClick, 
  disabled,
  options, 
  allResults,
  style
}) => {
  // 计算每个选项的匹配数量
  const optionsWithCount = useMemo(() => {
    if (!allResults || allResults.length === 0 || !options) {
      return options;
    }
    
    // 根据名称字段统计数量
    const counts = {};
    
    // 遍历所有结果
    allResults.forEach(result => {
      if (!result.rawData || !result.rawData.features) return;
      
      const feature = result.rawData.features[name];
      if (feature) {
        const featureValue = String(feature).toLowerCase();
        counts[featureValue] = (counts[featureValue] || 0) + 1;
      }
    });
    
    // 为选项添加计数
    return options.map(option => {
      if (option.value === 'none') {
        return option;
      }
      
      const count = counts[option.value.toLowerCase()] || 0;
      return {
        ...option,
        count,
        label: `${option.label} (${count})`
      };
    });
  }, [allResults, options, name]);
  
  // 特殊处理宽度和最小宽度
  const computedStyle = {
    ...style
  };
  
  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      className={className}
      onClick={onClick}
      disabled={disabled}
      style={computedStyle}
    >
      {optionsWithCount.map(option => (
        <option 
          key={option.value} 
          value={option.value}
          style={{
            fontWeight: option.count > 0 ? 'bold' : 'normal',
            color: option.count > 0 ? '#000' : '#666'
          }}
        >
          {option.label}
        </option>
      ))}
    </select>
  );
};

export default EnhancedSelect;